import clsx from "clsx";

import { flexRender, type Header } from "@tanstack/react-table";

interface TableHeaderProps<TData> {
  header: Header<TData, unknown>;
  index: number;
  headerGroupLength: number;
}

export const TableHeader = <TData,>({
  header,
  index,
  headerGroupLength,
}: TableHeaderProps<TData>) => {
  const isSticky = header.column.getIsPinned();

  let offset = 0;
  for (let i = 0; i < index; i++) {
    const previousHeader = header.headerGroup.headers[i];
    if (previousHeader.column.getIsPinned()) {
      offset += previousHeader.column.getSize();
    }
  }

  return (
    <th
      className={clsx(
        "text-left sticky top-0 bg-v2-primary py-2.5 z-2 border-none outline-none h-[32px]",
        {
          "rounded-tl-lg": index === 0,
          "rounded-tr-lg": index === headerGroupLength - 1,
          "z-3": isSticky,
          "cursor-pointer": header.column.getCanSort(),
        },
      )}
      style={{
        left: isSticky ? offset : "auto",
        width: `calc(var(--header-${header?.id}-size) * 1px)`,
      }}
    >
      <div className="border-r border-r-v2-secondary flex items-center relative justify-between pr-1">
        {
          flexRender(
            header.column.columnDef.header,
            header.getContext(),
          ) as React.ReactNode
        }
        {header.column.getCanResize() && (
          <div
            onDoubleClick={() => header.column.resetSize()}
            onMouseDown={header.getResizeHandler()}
            onTouchStart={header.getResizeHandler()}
            className="cursor-col-resize absolute top-0 h-full right-0 w-1.5 select-none touch-none"
          />
        )}
      </div>
      <div className="absolute bottom-0 left-0 right-0 w-full h-[1px] border-t border-t-v2-tertiary" />
    </th>
  );
};
